<div class="space">
  <img class="nf-img" src="/assets/v2-sample.jpg" alt="sample" />
  <div class="nf-title"><b>Not Found</b></div>
  <p>Oops, this route doesn't exist!</p>
  <a class="nf-link" href="/#/">Go to the main page.</a>
</div>

<style lang="scss">
  .nf-img {
    width: 250px;
    border-radius: 10px;
    margin-bottom: 30px;
  }

  .nf-title {
    color: $highlight-color;
    font-size: 1.3rem;
    margin-bottom: 10px;
  }

  .nf-link {
    color: $highlight-color;
    margin-top: 10px;
  }
  .space {
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
